import useTranslate from 'hooks/useTranslate';
import React from 'react'
import {BsArrowRightShort, BsCheckCircle} from 'react-icons/bs';
import {  MdErrorOutline} from 'react-icons/md';
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react';
import { useRequest } from 'hooks/useRequest';
import { dataLayerPush } from 'utils/Datalayer';
import auth from 'utils/Auth';

const OrderDetailIframe = () => {
    const [searchParams]= useSearchParams()
    const [request] = useRequest()
    const { t} = useTranslate()
    let error = searchParams.get('error')
    let orderId = searchParams.get('orderId')
    let iframe = searchParams.get('iframe') || true
    //iframe => true - false 

    useEffect(() => {
      if(!orderId) return

      request(`/Order/${orderId}`, {
        method: 'GET',
        headers: {
          RestaurantId : auth?.getUserChoises()?.restaurantId,
          DeliveryType : auth?.getUserChoises()?.deliveryType,
          NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
          RegionId : auth?.getUserChoises()?.regionId,
        },
      }).then((res) => {
        if (res?.data?.ok) {
          dataLayerPush({ ecommerce: null });
          dataLayerPush({
            event:"purchase",
            ecommerce: {
            item_list_name: "Listeleme Sayfası",
            currency: "TRY",
            value: res?.data?.result?.orderTotal,
            items: res?.data?.result?.orderItems?.map((prev, i) => ({
              item_id: prev.productId,
              item_name: prev.productName,
              affilication: "Tavuk Dünyası",
              discount: prev.discountAmount,
              index: i,
              item_brand: "Tavuk Dünyası",
              item_list_name: "Listeleme Sayfası",
              price: prev.unitPrice,
              quantity: prev.quantity
            }))
            }
          })
        }
      })
    }, [])

  return (
    <div className='orderIframeDetail' style={{position: iframe == 'true' ?'fixed':'unset',minHeight: iframe == 'true'?'unset':'60vh'}}>
        <div>
            {
               !orderId ? (
                <div className='orderIframeDetail-error'>
                    <MdErrorOutline size={80} color='#CD2B31' className='animated-icon'/>
                   <div>{error  ||  t('paymentError')} </div> 
                   <button onClick={()=> window.top.location = `/odeme`}>{t('backToPaymentPage')} <BsArrowRightShort size={26}/></button>
                </div> 
               ) : (
                <div className='orderIframeDetail-success'>
                        <BsCheckCircle size={70} color='#30A46C' className='animated-icon' />
                        <div>{t('yourOrderCompleted')}</div>  
                        <button onClick={()=> window.top.location = `/siparis/${orderId}?newOrder=${true}`}>{t('orderDetail')} <BsArrowRightShort size={26}/></button>
                </div>
               )
            }
        </div>
    </div>
  )
}

export default OrderDetailIframe